<template>
  <v-layout>
    <v-menu
      v-if="menu"
      v-model="menuActivator"
      :close-on-content-click="false"
      lazy
      min-width="290px"
      :nudge-right="40"
      offset-y
      full-width
      transition="scale-transition"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          :value="dateFormated"
          hide-details
          :height="44"
          readonly
          class="pa-0 ma-0"
          v-on="on"
        />
      </template>
      <v-date-picker
        v-model="date"
        no-title
        locale="ru-ru"
        first-day-of-week="1"
        :min="min"
        @input="changeDate"
      />
    </v-menu>
    <span
      v-else
      :class="typeof canEdit === 'boolean' && !canEdit ? '' : 'link'"
      @click="menu = typeof canEdit === 'boolean' && !canEdit ? false : true"
    >{{ dateFormated }}</span>
  </v-layout>
</template>

<script>
export default {
  props: ["value", "item", "min", "column", "canEdit", "store"],
  data() {
    return {
      date: "",
      menu: false,
      menuActivator: false,
    };
  },
  computed: {
    dateFormated() {
      if (!this.value) {
        return "_";
      }
      return this.moment(this.value).format("DD.MM.YY");
    },
  },
  watch: {
    value: {
      handler() {
        this.setDate();
      },
      immediate: true,
    },
    menu(value) {
      this.$nextTick(() => (this.menuActivator = value));
    },
    menuActivator(value) {
      if (!value) {
        this.menu = false;
      }
    },
  },
  methods: {
    setDate() {
      if (!this.value) {
        this.date = "";
        return;
      }
      this.date = this.moment(this.value).format("YYYY-MM-DD");
    },
    changeDate() {
      this.menu = false;
      const routeItem = { ...this.item };
      routeItem[this.column] = this.date;
      this.$store.commit(`${this.store}/setEditableRouteItem`, routeItem);
      this.$emit("input", this.date);
    },
  },
};
</script>
